import React from 'react';
import { ContentLoader } from '../ContentLoader';
import { useStatesForEducationForm } from './graphql';
import { Alert, Box, DateField, SingleSelectField, TextField } from '@medely/ui-kit';
import { DEGREE_PROGRAM_OPTIONS } from './constants';
import { useWatch } from '@medely/ui-kit/react-hook-form';

type EducationFormFieldsProps = {
  assignmentChecklistVariant: boolean;
};

export const EducationFormFields = ({ assignmentChecklistVariant }: EducationFormFieldsProps) => {
  const { states, isLoading: isLoadingStates } = useStatesForEducationForm();

  const statesOptions = states.map(({ name, id }) => ({
    value: id as number,
    label: name as string,
  }));

  const city = useWatch({ name: 'city' });

  const showInfoText = assignmentChecklistVariant && !city;

  return (
    <ContentLoader loading={isLoadingStates}>
      <>
        {showInfoText && (
          <Box p={1} mb={2}>
            <Alert
              description="Complete highlighted fields to continue with your application"
              severity="warning"
              testId="education-modal-complete-highlighted-fields"
              hideCloseIcon
            />
          </Box>
        )}
        <Box testId="education-modal-school-name" pb={1.5}>
          <TextField name="school_name" label="School *" />
        </Box>
        <Box py={1.5} testId="education-modal-city-name">
          <TextField name="city" label="City *" />
        </Box>
        <Box testId="education-modal-state" py={1.5}>
          <SingleSelectField label="State *" name="state_id" options={statesOptions} />
        </Box>
        <Box testId="education-modal-degree-type" py={1.5}>
          <SingleSelectField
            label="Degree/Program *"
            name="degree_type"
            options={DEGREE_PROGRAM_OPTIONS}
          />
        </Box>
        <Box py={1.5} testId="education-modal-field-of-study">
          <TextField name="field_of_study" label="Field of study *" />
        </Box>
        <Box testId="education-modal-end-date" pt={1.5}>
          <DateField name="end_date" label="Graduation date *" />
        </Box>
      </>
    </ContentLoader>
  );
};
